import * as Icons from "@nova/component-icons"
import { NovaSpinner } from "@nova/component-nova-spinner"
import { HTMLAttributes, MouseEvent, type JSX } from "react"
import { useLoadingText } from "../../../useLoadingText"
import classNames from "classnames"

export const WorkspaceHomeCTA = ({
    Icon,
    title,
    onClick,
    isLoading,
    disabled,
    loadingText,
    ...rest
}: {
    Icon: JSX.Element
    title: string
    onClick: (e: MouseEvent) => void
    isLoading?: boolean
    disabled?: boolean
    loadingText?: string
} & HTMLAttributes<HTMLDivElement>) => {
    loadingText = useLoadingText(!!isLoading, loadingText)
    return (
        <div
            {...rest}
            className={classNames(
                "relative flex-1 p-6 flex flex-col gap-4 border shadow-create-menu rounded-lg transition-colors duration-150 group select-none",
                {
                    "border-white-400 bg-white-200 cursor-pointer": !isLoading, // Normal
                    "hover:bg-transparent": !isLoading, // Hover
                    "active:bg-transparent active:border-lazeryellow": !isLoading, // Active
                    "border-blue-500": isLoading, // Loading
                },
                rest.className
            )}
            onClick={!disabled ? onClick : undefined}
        >
            {Icon}
            <div className="flex items-center justify-between h-6">
                <h4 className="text-gray-50 group-hover:text-gray-0 transition-colors duration-150">
                    {isLoading && !!loadingText ? loadingText : title}
                </h4>
                {isLoading ? (
                    <NovaSpinner width={24} height={24} />
                ) : (
                    <Icons.Icon
                        Icon={Icons.ArrowRight}
                        className="text-lazeryellow opacity-0 transition-opacity duration-150 group-hover:opacity-100"
                    />
                )}
            </div>
        </div>
    )
}
